import actions from "./actions";
import mutations from "./mutation";
export default {
  namespaced: true,
  state: {
    benefitAndDeductionTypes: [],
    benefitAndDeductionTypesCurrentPage: 1,
    benefitAndDeductionTypesPerPage: 5,
    benefitAndDeductionTypesTotal: null,
    tableLoading: false,
    searchQuery: "",
    benefitAndDeduction: [],
    benefitAndDeductionCurrentPage: 1,
    benefitAndDeductionPerPage: 5,
    benefitAndDeductionTotal: null,
    benefitAndDeductionApprovalSetting: [],
    approvalSettingTotal: null,
    approvalSettingCurrentPage: 1,
    approvalSettingPerPage: 5,
    approvals: [],
    approvalsTotal: null,
    approvalCurrentPage: 1,
    approvalPerPage: 5,
  },
  actions,
  mutations,
};
